(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7001],{

/***/ 96088:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/basedash.fb1a5610.png","height":132,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEUUFBRMaXEUFBQUFBQVFRUVFRUg6cLcAAAABnRSTlM/AGcwhiPWrtZ8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAG0lEQVQImWNgYWFmYGZgYGBgYmIFUQwMjFAAAAIiACDE01x9AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 12066:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/impira.e073a466.png","height":123,"width":537,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAASAQCkAAAAB3RSTlM/RjFebSNWGXPk5gAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUCJljYGRiZGBkZmBkYGFlYGJhZmADAAD5ACJt8n73AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 29358:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/knock.f920fb7c.png","height":111,"width":350,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUEBAQNBQQHBAQEBARMaXEEBAQEBAQEBAQAAwQrY+akAAAACXRSTlOPagqoAJqFgEHVxxVnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVQImWNgYQJBDkYGRgY2djZGBlYGBnZWZmYGNmYABEoAUT4VhGgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 75428:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/mage.a68f0773.png","height":142,"width":570,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAD1BMVEUAAAAAAAAAAAAAAAAAAABPDueNAAAABXRSTlNDUDeS4aNr4ukAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAWSURBVAiZY2BiYWZiYGBgZGAGMxgZAQEaABuwiNxCAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 81783:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/portal.98c21457.png","height":77,"width":250,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEUAAAAAAAAAAAAAAAAAAAAAAADgKxmiAAAABnRSTlNsWTFjgUEF1le7AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAGklEQVQImWNgYWZkYGJlYmZgYGBiZGBkZgEAAT0AIO1XJrYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 17565:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hero-bug-left.c1d860d6.gif","height":400,"width":400});

/***/ }),

/***/ 92905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* binding */ CompaniesReel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
;// CONCATENATED MODULE: ./public/images/companies/airplane.png
/* harmony default export */ var airplane = ({"src":"/_next/static/media/airplane.ef0c6262.png","height":116,"width":475,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEUAAAAEBgkNEBgAAAAAAAAMAxcSCBsJCRXvGuWLAAAACHRSTlMjNG0aQA5Lg/S+FJEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVAiZY2BkZ2VmYGBgZmBiYmNgYWRhBAABhAAotSJibAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/companies/basedash.png
var basedash = __webpack_require__(96088);
// EXTERNAL MODULE: ./public/images/companies/knock.png
var knock = __webpack_require__(29358);
;// CONCATENATED MODULE: ./public/images/companies/pipe.png
/* harmony default export */ var pipe = ({"src":"/_next/static/media/pipe.b1c6ce16.png","height":115,"width":394,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAG1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACUUeIgAAAACXRSTlOAoI0vlG5lR8bcG/bfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVQImWNgZGRmYmJiYGHgYGZnYmVkYwAAAYIAMNAScEcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/companies/impira.png
var impira = __webpack_require__(12066);
// EXTERNAL MODULE: ./public/images/companies/portal.png
var portal = __webpack_require__(81783);
;// CONCATENATED MODULE: ./public/images/companies/hightouch.png
/* harmony default export */ var hightouch = ({"src":"/_next/static/media/hightouch.999a8962.png","height":169,"width":531,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAG1BMVEUEBQgFBQgFBQgFBQgFBQgFBQgFBQgFBQgFBQgc8PHuAAAACXRSTlMEKll3ZzgOGU+PJIYuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIElEQVQImWNgYGBjYAARLMzMLCwcTCwMrEzsjKyMjOwAA00ASmiPEu4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/images/companies/dripos.png
/* harmony default export */ var dripos = ({"src":"/_next/static/media/dripos.5d498b60.png","height":72,"width":304,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAASAQCkAAAAB3RSTlNnUVyKMTN/stixzgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABdJREFUCJljYGZhZmQAQQYWBlY2RiYmAAEsACI8HrcnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./public/images/companies/mage.png
var mage = __webpack_require__(75428);
;// CONCATENATED MODULE: ./public/images/companies/secoda.svg
/* harmony default export */ var secoda = ({"src":"/_next/static/media/secoda.c127824d.svg","height":23,"width":135});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx

















const CompaniesReel = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).anchorFeature,
        id: "customers",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Home_module_default()).anchorHead,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: "Our customers"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                        type: "copy2",
                        onDark: true,
                        children: [
                            "Highlight powers forward-thinking companies.",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/customers",
                                children: "Find out more about our customers →"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Home_module_default()).customerReel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Home_module_default()).companies,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: pipe,
                            alt: "Pipe",
                            className: (Home_module_default()).scaleHeight,
                            style: {
                                transform: "scale(0.9)"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: portal/* default */.Z,
                            alt: "Portal",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: dripos,
                            alt: "Dripos",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: knock/* default */.Z,
                            alt: "Knock",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: hightouch,
                            alt: "Hightouch",
                            className: (Home_module_default()).scaleHeight,
                            style: {
                                transform: "scale(1.1)"
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: basedash/* default */.Z,
                            alt: "Basedash"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: impira/* default */.Z,
                            alt: "Impira",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: mage/* default */.Z,
                            alt: "Mage",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: airplane,
                            alt: "Airplane",
                            className: (Home_module_default()).scaleHeight
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Home_module_default()).tabletGraphic, (Home_module_default()).hideMobile)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: secoda,
                            alt: "Secoda",
                            className: (Home_module_default()).scaleHeight,
                            style: {
                                transform: "scale(0.8)"
                            }
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 83620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ REVIEWS; }
});

// EXTERNAL MODULE: ./public/images/companies/basedash.png
var basedash = __webpack_require__(96088);
// EXTERNAL MODULE: ./public/images/companies/knock.png
var knock = __webpack_require__(29358);
// EXTERNAL MODULE: ./public/images/companies/impira.png
var impira = __webpack_require__(12066);
// EXTERNAL MODULE: ./public/images/companies/portal.png
var portal = __webpack_require__(81783);
// EXTERNAL MODULE: ./public/images/companies/mage.png
var mage = __webpack_require__(75428);
;// CONCATENATED MODULE: ./public/images/avatars/basedash.jpg
/* harmony default export */ var avatars_basedash = ({"src":"/_next/static/media/basedash.47ad5664.jpg","height":500,"width":500,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAfEAAABgEFAAAAAAAAAAAAAAAAAQIDBRESBhMzQVH/xAAVAQEBAAAAAAAAAAAAAAAAAAACBP/EABgRAAMBAQAAAAAAAAAAAAAAAAABAhEx/9oADAMBAAIRAxEAPwCIzpaXOHfkDjHiSk0OJe3C4sTyOrvzqwABFSwNrh//2Q==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/avatars/knock.jpg
/* harmony default export */ var avatars_knock = ({"src":"/_next/static/media/knock.299b3f07.jpg","height":450,"width":450,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAABBAIDAAAAAAAAAAAAAAABAAIDEhMhBBFR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAwDAQACEQMRAD8AlxY+XJdsokk2ASKllewQPdFERFSv/9k=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/avatars/impira.jpg
/* harmony default export */ var avatars_impira = ({"src":"/_next/static/media/impira.0a659da8.jpg","height":447,"width":447,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAfEAABBAEFAQAAAAAAAAAAAAACAAEDESEEBQYxMnH/xAAVAQEBAAAAAAAAAAAAAAAAAAABAv/EABoRAAICAwAAAAAAAAAAAAAAAAABAnEDIUL/2gAMAwEAAhEDEQA/AKm96Rg5PGYkMMrsAxykT+baxrrOW+0iIogtuwyc0f/Z","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/avatars/portal.jpg
/* harmony default export */ var avatars_portal = ({"src":"/_next/static/media/portal.d26b1c83.jpg","height":500,"width":500,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAABBAIDAAAAAAAAAAAAAAADAAECEQQxEiLB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgT/xAAXEQEBAQEAAAAAAAAAAAAAAAABAAIS/9oADAMBAAIRAxEAPwCoOJRZpc2QpsMkeL3O6ZtddNXqIitzkJ9Lf//Z","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/avatars/mage.jpg
/* harmony default export */ var avatars_mage = ({"src":"/_next/static/media/mage.6583462a.jpg","height":349,"width":349,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAACAgEFAQAAAAAAAAAAAAABAgAFAxESISIxgf/EABUBAQEAAAAAAAAAAAAAAAAAAAUG/8QAGxEAAgIDAQAAAAAAAAAAAAAAAQIAERIhMVH/2gAMAwEAAhEDEQA/AJ5o7ZbtEId8D9jk42j77rERJx3exixGhyJKfRc//9k=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./components/Home/Reviews.ts










const REVIEWS = [
    {
        companyLogo: basedash/* default */.Z,
        scale: 1.2,
        text: "Highlight helps us catch bugs that would otherwise go undetected and makes it easy to replicate and debug them.",
        author: {
            image: avatars_basedash,
            name: "Max Musing",
            role: "Founder & CEO"
        }
    },
    {
        companyLogo: impira/* default */.Z,
        scale: 1,
        text: "Before Highlight, I was flying blind, but now I can see exactly where users are succeeding, failing, and running into issues.",
        author: {
            image: avatars_impira,
            name: "Lorilyn McCue",
            role: "Head of Product"
        }
    },
    {
        companyLogo: mage/* default */.Z,
        scale: 1,
        text: "Highlight weaves together the incredible, varied, and complex interactions of our users into something understandable and actionable.",
        author: {
            image: avatars_mage,
            name: "Kai Hess",
            role: "Founding Product Designer"
        }
    },
    {
        companyLogo: knock/* default */.Z,
        scale: 0.9,
        text: "I love Highlight because not only does it help me debug more quickly, but it gives me insight into how customers are actually using our product.",
        author: {
            image: avatars_knock,
            name: "Meryl Dakin",
            role: "Founding Software Engineer"
        }
    },
    {
        companyLogo: portal/* default */.Z,
        text: "Highlight has helped us win over several customers by making it possible for us to provide hands-on support, based on a detailed understanding of what each user was doing.",
        author: {
            image: avatars_portal,
            name: "Neil Raina",
            role: "CTO"
        }
    }
];


/***/ }),

/***/ 15099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Products_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49879);
/* harmony import */ var _Products_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Products_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20026);
/* harmony import */ var _components_common_Buttons_PrimaryButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29204);






//Component for the image/text row for the footer of the product page
//invert puts the image on the right side of the text
const InfoRow = (param)=>{
    let { title , desc , link , invert , imgSrc  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col lg:flex-row justify-center items-center gap-16 xl:gap-32",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat(invert ? "lg:hidden " : "", " flex justify-center lg:w-[570px]"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: imgSrc,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "lg:w-1/2 text-center lg:text-left",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: (_Products_module_scss__WEBPACK_IMPORTED_MODULE_5___default().infoTitle),
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                        type: "copy2",
                        onDark: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-color-copy-on-dark md:text-xl",
                            children: desc
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex justify-center lg:justify-start",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Buttons_PrimaryButton__WEBPACK_IMPORTED_MODULE_4__/* .PrimaryButton */ .K, {
                            href: link,
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Products_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hollowButton), (_Products_module_scss__WEBPACK_IMPORTED_MODULE_5___default().docsButton), "mt-5"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_Typography_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .Z, {
                                type: "copy2",
                                emphasis: true,
                                children: "Read our docs"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat(invert ? "lg:flex" : "", " hidden justify-center lg:w-[570px]"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: imgSrc,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoRow);


/***/ }),

/***/ 10198:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const highlightCodeTheme = {
    lineNumberColor: "#6272a4",
    lineNumberBgColor: "#282a36",
    backgroundColor: "#282a36",
    textColor: "#FFFFFF",
    substringColor: "#36E79B",
    keywordColor: "#FF5377",
    attributeColor: "#FF9457",
    selectorTagColor: "#8be9fd",
    docTagColor: "#36E79B",
    nameColor: "#66d9ef",
    builtInColor: "#FF9457",
    literalColor: "#FF5377",
    bulletColor: "#8BE9FD",
    codeColor: "#FF9457",
    additionColor: "#36E79B",
    regexpColor: "#36E79B",
    symbolColor: "#36E79B",
    variableColor: "#FFFFFF",
    templateVariableColor: "#FF5377",
    linkColor: "#00bcd4",
    selectorAttributeColor: "#FF5377",
    selectorPseudoColor: "#FF5377",
    typeColor: "#8BE9FD",
    stringColor: "#36E79B",
    selectorIdColor: "#FF9457",
    selectorClassColor: "#FF9457",
    quoteColor: "#E9F284",
    templateTagColor: "#FF5377",
    deletionColor: "#FF5377",
    titleColor: "#ff5580",
    sectionColor: "#FFFFFF",
    commentColor: "#6272A4",
    metaKeywordColor: "#FF9457",
    metaColor: "#FF9457",
    functionColor: "#FF9457",
    numberColor: "#bd93f9"
};
/* harmony default export */ __webpack_exports__["Z"] = (highlightCodeTheme);


/***/ }),

/***/ 62223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Section; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50246);
/* harmony import */ var _Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3__);




const Section = (param)=>{
    let { reverseMobile , className , children , noYBottomPadding , noYTopPadding , grid , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        ...props,
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(className, (_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().section), {
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().sectionReverseMobile)]: reverseMobile,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYTopPadding)]: noYTopPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().noYBottomPadding)]: noYBottomPadding,
            [(_Section_module_scss__WEBPACK_IMPORTED_MODULE_3___default().gridSection)]: grid
        }),
        children: children
    });
};


/***/ }),

/***/ 97001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "CustomerReview": function() { return /* binding */ CustomerReview; },
  "FeatureItem": function() { return /* binding */ FeatureItem; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/common/Buttons/PrimaryButton.tsx
var PrimaryButton = __webpack_require__(29204);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 3 modules
var Navbar = __webpack_require__(77911);
// EXTERNAL MODULE: ./components/common/Section/Section.tsx
var Section = __webpack_require__(62223);
// EXTERNAL MODULE: ./components/Home/Home.module.scss
var Home_module = __webpack_require__(19350);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
;// CONCATENATED MODULE: ./public/images/mobile-insects.png
/* harmony default export */ var mobile_insects = ({"src":"/_next/static/media/mobile-insects.45988f44.png","height":376,"width":375,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAclBMVEVMaXGOc9ItHVgnE1qXcP15UONlMe/+892DbMOm1Ok1ImlqOehxYZwmE1dCIZfHvuA/KHuXitmcm9xeQqplNt6gl7uYouK62PtwRONoLvmgefVqNvH+/zw/CMqqkuu8vr5/hHVaMMVZLMsWCThCIpW1t+h+iJvNAAAAInRSTlMA/DTwFP1oBf0nY1KCcf1oO408/P2e1JzR+FjkHDyoWUypC4NP/gAAAAlwSFlzAAALEwAACxMBAJqcGAAAAEFJREFUCJkFwYcBgCAQALFDgQd77xV1/xVNgCQHIiCrRKcxIPTmffB1Y5VrC8pvmGbnOvy4cJgQAE512xVku3bQP1zqAxmn50z2AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./public/images/hero-bug-left.gif
var hero_bug_left = __webpack_require__(17565);
// EXTERNAL MODULE: ./public/images/hero-bug-right.gif
var hero_bug_right = __webpack_require__(52417);
;// CONCATENATED MODULE: ./public/images/landingInfoRow1.png
/* harmony default export */ var landingInfoRow1 = ({"src":"/_next/static/media/landingInfoRow1.67f45869.png","height":471,"width":780,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAFVBMVEUOAicVCDEUCC4cFDghHUEnLFMzSHNMrHIhAAAAAnRSTlP+/T+gj6oAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAmSURBVAiZFca5CQAwEASx2c/9l2wOFAiQLcBZk8te25Tz5rBJYH0ILwBkr2/l8gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/landingInfoRow2.png
/* harmony default export */ var landingInfoRow2 = ({"src":"/_next/static/media/landingInfoRow2.c5a8d79c.png","height":505,"width":632,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAKlBMVEUIACNJK0MxMEBcGDAlMVYoME4sM1hbM0YnHjkfKkYfHjhVSUo9Q1VxQkx3Baq1AAAACXBIWXMAAAsTAAALEwEAmpwYAAAALElEQVQImUXGuQEAIAgEwUUO8O2/XQMDJxporc868FJApjI2IIVsAe5mI34uFnwAv9KFicgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/landingInfoRow3.png
/* harmony default export */ var landingInfoRow3 = ({"src":"/_next/static/media/landingInfoRow3.b63d64a3.png","height":505,"width":632,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAJ1BMVEUIACMnIlMqIEghLmANACA/HzMzKEAzKGxYTWllXHZCOFU1Mkw9LHRAeFaEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALUlEQVQImT3GyREAIAgAseVUwf7rdfiYVyBiXW2YrExws2wxn1SpOKiK7MPPAxb1AMVQ99JQAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/landingInfoRowSecurity.png
/* harmony default export */ var landingInfoRowSecurity = ({"src":"/_next/static/media/landingInfoRowSecurity.7b55fb59.png","height":1150,"width":1264,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAQlBMVEUNAiVHZKwWDTAGAB2uvOQ4QnU4regNAiVHQF3y+P8NAiUQBSgnKFMkHUJ8eJAkPmo0XZgthb+Wl7GurLw6S4coUHwrsAClAAAACnRSTlPU/v///v7+w/7+MuWvdQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAADpJREFUCJkdyEcSgDAQAzBjAwlbUij//yoDOgocs8fYCM79ieUmPDoZ6TCxNcrgqutR9U2eV8pQ8CsvQOQBz7Cp3woAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/Home/CompaniesReel/CompaniesReel.tsx + 5 modules
var CompaniesReel = __webpack_require__(92905);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Home/Reviews.ts + 5 modules
var Reviews = __webpack_require__(83620);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/antd/es/collapse/index.js + 37 modules
var collapse = __webpack_require__(52865);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./public/images/session-replay.png
/* harmony default export */ var session_replay = ({"src":"/_next/static/media/session-replay.6a7e665d.png","height":2036,"width":1984,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEX39ve5ovKsj/OUbvNWT2jQwPe+qvAEAB/Juu1/UvPd1PL3+PPy8PT////+/v0eFTf////y8fPl5One2en19/Xs7Ozp6Or8/vminaknIjp9eIq+ttWkm77GwNVpfvybAAAAEXRSTlP9eGFJ/ciS/qok4+HBW4z8c4GVh18AAAAJcEhZcwAALEsAACxLAaU9lqkAAABBSURBVAiZBcEHAoAgDACxU1HA3VaW4//fNCHOyxr2cyOaJL73YTA1nD/oTQTnG52BNO+ZFJFab0JCklyFsUBWzT91tQNfKOANKwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/error-monitoring.png
/* harmony default export */ var error_monitoring = ({"src":"/_next/static/media/error-monitoring.5b4b3d3b.png","height":1975,"width":1787,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAANlBMVEXx8PL////////k2/vq4/vVxvz5+vn29fbo6Org3+H///+7o/q9pP3Hs/z39/f////6+frZ2NvUVygOAAAADnRSTlP9YnzT6bvC/v7+mFV6lEj1YyAAAAAJcEhZcwAALEsAACxLAaU9lqkAAAA2SURBVAiZBcGJAYAgEAPBVYGAT3L036wzPIxxnwfv3HuvySeJuegCLHpV2eaCJKFZSZkWJdYPO/YCEWmjTo8AAAAASUVORK5CYII=","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/fullstack-logging.png
/* harmony default export */ var fullstack_logging = ({"src":"/_next/static/media/fullstack-logging.36bc863e.png","height":1880,"width":1796,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEXx8fL6+fnFsPi6ofhqPf/QwPf8+/z09PXOv/Xj3u6IXPnz9O/v7fLWy/Gjgfjs7Ovt7O74+fbq6ur+/f7k4+Xq5vVIDbjBAAAAFHRSTlP+iZp4D+Nm/sm6OfPX9lj6/////qRxE90AAAAJcEhZcwAALEsAACxLAaU9lqkAAAA+SURBVAiZFcZbEoAwCATBUaMkvmqBcP+rWvZX0/p1j7EctCfmVBpnGSKNtyBwZysUMY0VQwqnO3+S3ZGk/ABhDQLTxqSEywAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/docker.png
/* harmony default export */ var docker = ({"src":"/_next/static/media/docker.b3272830.png","height":2059,"width":1891,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAOVBMVEX9/f0uac3c0vpumN5EeNSzqvfn4Pno4Pv19fTx8O5rlt6HgOt+od/Rw/r+/v75+fri6fHI1/K50+nqwH6WAAAADnRSTlP+cMrRlZzx3v38um36vUhMBaUAAAAJcEhZcwAALEsAACxLAaU9lqkAAAA1SURBVAiZFcVJEoAgEATBAllFu0f+/1iDvCTrue5SEjUi4tvUPeYEXpAEGQTQ5WHpbAMNHz89GAH4Mt4FHgAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/open-source.png
/* harmony default export */ var open_source = ({"src":"/_next/static/media/open-source.0a04c973.png","height":1887,"width":1922,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAQlBMVEX09ffk2/4pLTIzNzs6PkTTxPvl3v3////i5e3f0f7h1v0zNzxpa3d0YqtUWV33+frt7/Hw8vXa3eC4u76rrrHJy86HUP01AAAAEnRSTlP+0mR5tGnq/v6WupD1SNf///5tzpJJAAAACXBIWXMAACxLAAAsSwGlPZapAAAAO0lEQVQImQXBCQKAIBADsVHABa92Uf//VROu8671KCut9zm/56UBighGdtsJQxlKJ7sILLFAyIYNBYYfWvwCY2BkTh0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/githubscreenshot.png
/* harmony default export */ var githubscreenshot = ({"src":"/_next/static/media/githubscreenshot.fb4645ff.png","height":996,"width":1789,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAHlBMVEXz8Pvq6PXt5v7u7fnAxsX7/P3w9fXKzND19vzQ0tTPqnGeAAAABXRSTlP9/f37/haSW8kAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAlSURBVAiZFcGBEQAgCAOxR6Qt+y/smWDv+trMp4SMNFJoqijOAw4HAKMFqTP9AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/dockerscreenshot.png
/* harmony default export */ var dockerscreenshot = ({"src":"/_next/static/media/dockerscreenshot.e67480fe.png","height":894,"width":1322,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAKlBMVEXs6Pq/zevG1vHy6//Q5PLg2/DIxNbQxez////4+vv49/Pw8e7S1tDg2+2FDs+VAAAACHRSTlP7/v7+/vz8/C9edsoAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAArSURBVAiZHcbJEQAgDMNA21xOgP7bZYI+K4ikJKJn2nZDhB01n30uqjbmehMJAOgQ8lv0AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/loggingscreenshot.png
/* harmony default export */ var loggingscreenshot = ({"src":"/_next/static/media/loggingscreenshot.46986851.png","height":973,"width":1546,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAElBMVEX09PTu7fDo4/P+/v7y7f34+Pp4c5d6AAAAA3RSTlP+/v6VFoksAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAJUlEQVQImR3GwREAMAjDMDuQ/VfuFb2EsUBA25n9cS7IxSS7zQMG1wBWBjw9JQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/monitoringscreenshot.png
/* harmony default export */ var monitoringscreenshot = ({"src":"/_next/static/media/monitoringscreenshot.6f76b251.png","height":1069,"width":1349,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAG1BMVEX19fbv6vvq4/zm5efd0vvq6PD+/v34+fju7e8bATizAAAABnRSTlP+3f7+3+/frd1nAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAKklEQVQImSXIwQkAMAzDQDUutvefuITeS4hKUjvQtskQSPAAXnvsbJzvPhe4AMfxdgN7AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/sessionscreenshot.png
/* harmony default export */ var sessionscreenshot = ({"src":"/_next/static/media/sessionscreenshot.2415984d.png","height":1198,"width":1907,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAM1BMVEXr5vWNiJvv6/n29/jo5umyrMKsp72clqru7e97eIrw7Pz19fTh2/D8/voAABQjGTw/NlRikKCdAAAACnRSTlP+/v7//f7+/vz+PiFaHQAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAC5JREFUCJkFwYkBwCAMA7ErbgnE4dl/2koMvogueH33PkqGYs5HDdtryQlUQdYPGYoBJ91LpnYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.esm.js + 1 modules
var embla_carousel_react_esm = __webpack_require__(57434);
// EXTERNAL MODULE: ./node_modules/react-icons/hi/index.esm.js
var index_esm = __webpack_require__(53854);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var next_image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/common/CodeBlock/highlight-code-theme.ts
var highlight_code_theme = __webpack_require__(10198);
// EXTERNAL MODULE: ./node_modules/react-code-blocks/dist/react-code-blocks.esm.js + 13 modules
var react_code_blocks_esm = __webpack_require__(41443);
// EXTERNAL MODULE: ./components/Animate.tsx
var Animate = __webpack_require__(60216);
;// CONCATENATED MODULE: ./components/Home/FeatureCarousel/DesktopCard.tsx











const DesktopImage = (param)=>{
    let { feature  } = param;
    const [imageLoaded, setImageLoaded] = (0,react.useState)(false);
    function handleLoad() {
        setImageLoaded(true);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "hidden sm:flex w-1/2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "absolute right-0 top-0 bottom-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateCarouselImage */.O6, {
                loaded: imageLoaded,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                    className: "".concat(feature.right ? "right-0" : "left-0", " object-contain absolute bottom-0 sm:w-[280px] md:w-[300px] lg:w-[450px] xl:w-[450px]"),
                    src: feature.desktopImage,
                    alt: "Feature Spotlight",
                    onLoadingComplete: ()=>handleLoad()
                })
            })
        })
    });
};
const DesktopFeatures = (param)=>{
    let { feature  } = param;
    const [imageLoaded, setImageLoaded] = (0,react.useState)(false);
    function handleLoad() {
        setImageLoaded(true);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(feature.code ? "md:w-1/2" : "md:w-2/3", " flex flex-col justify-between h-full  sm:w-1/2 px-5"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col gap-4 justify-start md:pt-8 text-left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                className: "hidden sm:flex",
                                children: feature.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "sm:hidden",
                                children: feature.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                className: "text-copy-on-dark md:text-[18px]",
                                children: feature.description
                            })
                        ]
                    }),
                    feature.code ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_code_blocks_esm/* Code */.EK, {
                        language: "bash",
                        text: feature.code.join("\n"),
                        showLineNumbers: false,
                        theme: highlight_code_theme/* default */.Z,
                        wrapLines: true
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-3 mt-3 rounded-lg",
                        children: [
                            feature.feature1Link ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: feature.feature1Link,
                                target: "_blank",
                                rel: "noreferrer noopener",
                                className: (Home_module_default()).innerCarouselButton,
                                children: [
                                    feature.featureImage1,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: feature.feature1
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Home_module_default()).innerCarouselFeature,
                                children: [
                                    feature.featureImage1,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: feature.feature1
                                    })
                                ]
                            }),
                            feature.feature2Link ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: feature.feature2Link,
                                target: "_blank",
                                rel: "noreferrer noopener",
                                className: (Home_module_default()).innerCarouselButton,
                                children: [
                                    feature.featureImage2,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: feature.feature2
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Home_module_default()).innerCarouselFeature,
                                children: [
                                    feature.featureImage2,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: feature.feature2
                                    })
                                ]
                            }),
                            feature.feature3Link ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: feature.feature3Link,
                                target: "_blank",
                                rel: "noreferrer noopener",
                                className: (Home_module_default()).innerCarouselButton,
                                children: [
                                    feature.featureImage3,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: feature.feature3
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Home_module_default()).innerCarouselFeature,
                                children: [
                                    feature.featureImage3,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        emphasis: true,
                                        children: feature.feature3
                                    })
                                ]
                            })
                        ]
                    }),
                    feature.link && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center sm:justify-start mb-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "".concat(feature.link),
                            target: "_blank",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy3",
                                emphasis: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-center gap-2",
                                    children: [
                                        "Learn More ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiArrowRight */.WY3, {
                                            className: "h-5"
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex sm:hidden justify-center w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                    className: "object-contain max-h-[200px] ",
                    src: feature.mobileImage,
                    alt: "Feature Spotlight",
                    onLoadingComplete: ()=>handleLoad()
                })
            })
        ]
    });
};
const DesktopCard = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative flex w-full md:h-[475px] lg:h-[525px] border-x-0 sm:border-y-[1px] md:border-x-[1px] border-divider-on-dark flex-shrink-0 snap-always snap-center xl:rounded-br-lg xl:rounded-bl-lg overflow-y-hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-5 py-8 border-[1px] sm:border-none border-divider-on-dark rounded-lg",
            children: props.feature.right ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopFeatures, {
                        feature: props.feature
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopImage, {
                        feature: props.feature
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopImage, {
                        feature: props.feature
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopFeatures, {
                        feature: props.feature
                    })
                ]
            })
        })
    }, props.index);
};

// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/ExclamationCircleFilled.js + 1 modules
var ExclamationCircleFilled = __webpack_require__(21640);
;// CONCATENATED MODULE: ./components/Home/FeatureCarousel/FeatureCarousel.tsx






















//feature images need classname "h-[20px] w-[20px]"
//thumbnail needs classname "h-[35px] w-[35px]"
const features = [
    {
        name: "Session Replay",
        title: "Session Replay",
        description: "Understand the real reason why bugs are happening in your web application.",
        thumbnail: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiFilm */.LhU, {
            className: "h-[35px] w-[35px]"
        }),
        desktopImage: session_replay,
        mobileImage: sessionscreenshot,
        right: true,
        feature1: "Console and Network Recording",
        featureImage1: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiTerminal */.Zbf, {
            className: "h-[20px] w-[20px]"
        }),
        feature2: "Comprehensive Session Search",
        featureImage2: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiDocumentSearch */.m3O, {
            className: "h-[20px] w-[20px]"
        }),
        feature3: "Powerful Privacy Controls",
        featureImage3: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiPhoneOutgoing */.BsK, {
            className: "h-[20px] w-[20px]"
        }),
        link: "/docs/general/product-features/session-replay/overview"
    },
    {
        name: "Error Monitoring",
        title: "Error Monitoring",
        description: "Get notified of the exceptions across your app before they become problematic.",
        thumbnail: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiTerminal */.Zbf, {
            className: "h-[35px] w-[35px]"
        }),
        desktopImage: error_monitoring,
        mobileImage: monitoringscreenshot,
        right: true,
        feature1: "Custom Error Grouping",
        featureImage1: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiUserGroup */.IKj, {
            className: "h-[20px] w-[20px]"
        }),
        feature2: "Customizable Alerting Rules",
        featureImage2: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiViewBoards */.YbG, {
            className: "h-[20px] w-[20px]"
        }),
        feature3: "Powered by Open Telemetry",
        featureImage3: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationCircleFilled/* default */.Z, {
            className: "h-[20px] w-[20px]"
        }),
        link: "/docs/general/product-features/error-monitoring/overview"
    },
    {
        name: "Logging",
        title: "Logging",
        description: "Drill down on all the logs being written throughout your stack to uncover issues.",
        thumbnail: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiLightningBolt */.NNQ, {
            className: "h-[35px] w-[35px]"
        }),
        desktopImage: fullstack_logging,
        mobileImage: loggingscreenshot,
        right: true,
        feature1: "Customizable Log Alerts",
        featureImage1: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiBell */.p0b, {
            className: "h-[20px] w-[20px]"
        }),
        feature2: "Widespread SDK Support",
        featureImage2: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiCode */.aJo, {
            className: "h-[20px] w-[20px]"
        }),
        feature3: "Powered by Clickhouse",
        featureImage3: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiDatabase */.tQn, {
            className: "h-[20px] w-[20px]"
        }),
        link: "/docs/general/product-features/logging/overview"
    },
    {
        name: "Self-Hosting",
        title: "Self-Hosting highlight.io",
        description: "Interested in self-hosting highlight? Spin up highlight.io in docker with just a few commands.",
        thumbnail: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiCloudDownload */.EKd, {
            className: "h-[35px] w-[35px]"
        }),
        desktopImage: docker,
        mobileImage: dockerscreenshot,
        right: true,
        code: [
            "git clone --recurse-submodules https://github.com/highlight/highlight;",
            "cd docker;",
            "docker compose up -d --build;"
        ],
        link: "/docs/general/company/open-source/self-host-hobby"
    },
    {
        name: "Open Source",
        title: "We're Open Source!",
        description: "highlight.io is an open source tool for debugging your web application.",
        thumbnail: /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiFillGithub */.RrF, {
            className: "h-[35px] w-[35px]"
        }),
        desktopImage: open_source,
        mobileImage: githubscreenshot,
        right: true,
        feature1: "Join the Community",
        feature1Link: "https://discord.gg/yxaXEAqgwN",
        featureImage1: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiPresentationChartLine */.E9Y, {
            className: "h-[20px] w-[20px]"
        }),
        feature2: "Find us on GitHub",
        feature2Link: "https://github.com/highlight/highlight/",
        featureImage2: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiDesktopComputer */.BpP, {
            className: "h-[20px] w-[20px]"
        }),
        feature3: "Self host highlight.io",
        feature3Link: "/docs/general/company/open-source/self-host-hobby",
        featureImage3: /*#__PURE__*/ (0,jsx_runtime.jsx)(ExclamationCircleFilled/* default */.Z, {
            className: "h-[20px] w-[20px]"
        })
    }
];
const FeatureCarousel = ()=>{
    const [selected, setSelected] = (0,react.useState)(0);
    const [emblaRef, emblaApi] = (0,embla_carousel_react_esm/* default */.Z)({
        loop: false,
        draggable: false
    });
    (0,react.useEffect)(()=>{
        if (emblaApi) {
            emblaApi.scrollTo(selected);
            emblaApi.on("select", ()=>{
                setSelected(emblaApi.selectedScrollSnap());
            });
        }
        document.getElementById("dropdown").value = selected.toString();
    }, [
        emblaApi,
        selected
    ]);
    const handleDropdown = ()=>{
        let dropdownValue = parseInt(document.getElementById("dropdown").value);
        setSelected(dropdownValue);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col overflow-x-hidden xl:rounded-lg max-w-[100vw] xl:max-w-[1000px] xl:rounded-tr-lg xl:rounded-tl-lg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden md:grid grid-cols-5",
                children: features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: ()=>setSelected(index),
                        className: classnames_default()((Home_module_default()).carouselButton, "group", index == 0 ? "xl:rounded-tl-lg" : "", index == features.length - 1 ? "xl:rounded-tr-lg" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat(selected == index ? "bg-divider-on-dark" : "group-hover:bg-divider-on-dark group-hover:bg-opacity-75", " h-full flex justify-center gap-1 px-3 py-2 rounded-lg transition-all"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center text-color-copy-on-dark",
                                        children: feature.thumbnail
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                        type: "copy3",
                                        className: "text-center",
                                        emphasis: true,
                                        children: feature.name
                                    })
                                ]
                            })
                        })
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                type: "copy4",
                className: "md:hidden mb-3 text-copy-on-light",
                children: "Explore Our Features"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex md:hidden justify-center mx-5 mb-8 rounded-lg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                        className: classnames_default()((Home_module_default()).whiteButton, "w-full border-copy-on-dark py-0 px-0 h-[54px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                            type: "copy2",
                            className: "bg-color-primary-500 rounded-lg w-full",
                            emphasis: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                onChange: ()=>handleDropdown(),
                                id: "dropdown",
                                className: "w-full px-4 bg-color-primary-500 h-full text-center rounded-lg appearance-none",
                                children: features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: index,
                                        children: feature.name
                                    }, index))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* HiChevronDown */.kWQ, {
                        className: "absolute text-color-copy-on-dark h-[20px] w-[20px] top-4 right-5"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full",
                ref: emblaRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex scrollbar-hide md:gap-4",
                    children: features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopCard, {
                            feature: feature,
                            index: index
                        }, index))
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var fa_index_esm = __webpack_require__(89583);
;// CONCATENATED MODULE: ./components/common/CallToAction/OSSCallToAction.tsx








const OSSCallToAction = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center mx-5 md:mx-[10vw] my-10 md:my-40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Home_module_default()).ossCard, "w-full max-w-[1250px] border-[1px] border-divider-on-dark rounded-3xl py-10 px-2"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                    className: "text-center leading-normal",
                    children: [
                        "Join our ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Home_module_default()).highlightedText,
                            children: "open source"
                        }),
                        " community."
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-center px-2 md:px-16 mt-6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                        type: "copy1",
                        className: "leading-relaxed",
                        children: [
                            "Have a feature request? Or want to build the future of Highlight?",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Check us out and join the fun!"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex justify-center mt-16",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col lg:flex-row justify-center gap-4 w-full px-5 md:w-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                href: "https://github.com/highlight/highlight",
                                className: "md:max-w-[145px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-center items-center gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ai_index_esm/* AiFillGithub */.RrF, {
                                            className: "w-6 h-6 mb-[1px]"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            emphasis: true,
                                            children: "GitHub"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                href: "https://discord.gg/yxaXEAqgwN",
                                className: classnames_default()((Home_module_default()).hollowButton, "md:max-w-[145px]"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center gap-3 ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(fa_index_esm/* FaDiscord */.j2d, {
                                            className: "w-6 h-6"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                            type: "copy2",
                                            emphasis: true,
                                            className: "",
                                            children: "Discord"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./components/Products/Products.module.scss
var Products_module = __webpack_require__(49879);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
;// CONCATENATED MODULE: ./components/Home/LandingInfoRow.tsx







//Component for the image/text row for the footer of the product page
//invert puts the image on the right side of the text
const LandingInfoRow = (param)=>{
    let { title , desc , link , linkText , invert , imgSrc  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).landingInfoRow,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(invert ? "lg:hidden" : "", " flex justify-center px-5 mt-5 min-h-[200px] sm:h-[300px] lg:h-auto lg:w-[570px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                    className: "object-scale-down sm:object-contain",
                    src: imgSrc,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex md:hidden w-full h-[1px] bg-divider-on-dark",
                children: " "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-between h-full lg:w-1/2 px-5 text-left lg:text-left",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (Products_module_default()).infoTitle,
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy2",
                                onDark: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-color-copy-on-dark md:text-xl",
                                    children: desc
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                            href: link,
                            className: classnames_default()((Products_module_default()).hollowButton, (Products_module_default()).docsButton, "lg:mt-5"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy2",
                                emphasis: true,
                                children: linkText
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat(invert ? "lg:flex" : "", " hidden justify-center lg:w-[570px]"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((next_image_default()), {
                    src: imgSrc,
                    alt: ""
                })
            })
        ]
    });
};
/* harmony default export */ var Home_LandingInfoRow = (LandingInfoRow);

// EXTERNAL MODULE: ./components/Products/InfoRow.tsx
var InfoRow = __webpack_require__(15099);
;// CONCATENATED MODULE: ./pages/index.tsx



























const IMAGE_SHOW_OFFSET = 450;
const { Panel  } = collapse/* default */.Z;
const FeatureItem = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ...props,
        className: (Home_module_default()).featureItem,
        children: children
    });
};
const CustomerReview = (param)=>{
    let { companyLogo , text , author , scale  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Home_module_default()).reviewCard,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Home_module_default()).companyLogo,
                style: {
                    width: "".concat(120 * (scale || 1), "px"),
                    objectFit: "contain"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: companyLogo,
                    alt: author.name,
                    layout: "fill",
                    objectFit: "contain",
                    style: {
                        transform: "scale(".concat(scale || 1, ")")
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Home_module_default()).reviewText,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    type: "copy2",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: text
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Home_module_default()).author,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Home_module_default()).authorImage,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: author.image,
                            alt: author.name
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy2",
                                emphasis: true,
                                children: author.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                type: "copy2",
                                children: ", ".concat(author.role)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const Home = ()=>{
    const reviewsRef = (0,react.useRef)(null);
    const scrollYPosition = (0,react.useRef)(0);
    const [scrollReviews, setScrollReviews] = (0,react.useState)(false);
    const [leftBugLoaded, setLeftBugLoaded] = (0,react.useState)(false);
    const [rightBugLoaded, setRightBugLoaded] = (0,react.useState)(false);
    const scrollListener = (0,react.useCallback)(()=>{
        if (!scrollReviews) {
            return;
        }
        if (reviewsRef.current) {
            const { scrollY  } = window;
            const scrollingDown = scrollYPosition.current > scrollY;
            // Adjust this value to control scroll speed
            const scrollDistance = scrollingDown ? -3 : 3;
            reviewsRef.current.scrollLeft += scrollDistance;
            scrollYPosition.current = scrollY;
        }
    }, [
        scrollReviews
    ]);
    (0,react.useEffect)(()=>{
        window.removeEventListener("scroll", scrollListener);
        window.addEventListener("scroll", scrollListener);
        return ()=>window.removeEventListener("scroll", scrollListener);
    }, [
        scrollListener
    ]);
    (0,react.useEffect)(()=>{
        // invoke the sitemap api to validate next metrics integration
        fetch("/sitemap.xml").then((r)=>r.text());
    }, []);
    (0,react.useEffect)(()=>{
        const reviewsElement = reviewsRef.current;
        const observer = new IntersectionObserver((param)=>{
            let [entry] = param;
            setScrollReviews(entry.isIntersecting);
        }, {
            root: null,
            rootMargin: "250px 0px",
            threshold: 0
        });
        if (reviewsElement) {
            observer.observe(reviewsElement);
            // Scroll to center on load
            reviewsElement.scrollLeft = (reviewsElement.scrollWidth - window.innerWidth) / 2;
        }
        return ()=>{
            if (reviewsElement) {
                observer.unobserve(reviewsElement);
            }
        };
    }, [
        reviewsRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                hideBanner: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* Section */.$, {
                        className: (Home_module_default()).heroVideoWrapper,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateBugLeft */.ds, {
                                loaded: leftBugLoaded && rightBugLoaded,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Home_module_default()).heroBug,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: hero_bug_left/* default */.Z,
                                        alt: "bug left",
                                        onLoadingComplete: ()=>setLeftBugLoaded(true)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Animate/* AnimateBugRight */.nw, {
                                loaded: leftBugLoaded && rightBugLoaded,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Home_module_default()).heroBug,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: hero_bug_right/* default */.Z,
                                        alt: "bug right",
                                        onLoadingComplete: ()=>setRightBugLoaded(true)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Home_module_default()).anchorFeature,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        className: classnames_default()((Home_module_default()).landingAnchorHead),
                                        children: [
                                            "The open source, fullstack ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-highlight-yellow",
                                                children: "Monitoring Platform."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-center mt-8 mb-16",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col sm:flex-row justify-center gap-4 w-screen sm:w-auto px-5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                    className: classnames_default()((Home_module_default()).solidButton, "min-w-[180px]"),
                                                    href: "https://app.highlight.io/?sign_up=1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        type: "copy2",
                                                        emphasis: true,
                                                        children: "Get started"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryButton/* PrimaryButton */.K, {
                                                    href: "/docs",
                                                    className: classnames_default()((Home_module_default()).hollowButton),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                                                        type: "copy2",
                                                        emphasis: true,
                                                        children: "Read our docs"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureCarousel, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).anchorFeature,
                            id: "features",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Home_module_default()).anchorTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    children: [
                                        "Web application monitoring for",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (Home_module_default()).highlightedText,
                                            children: "today's developer."
                                        }),
                                        " "
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Home_module_default()).infoContainer,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LandingInfoRow, {
                                title: "A cohesive view of your entire stack.",
                                desc: "A natural pairing between your errors, session replay, logs and more. Understand the “what”, “why” and “how” of your full-stack web application.",
                                link: "https://app.highlight.io/?sign_up=1",
                                linkText: "Get started for free",
                                imgSrc: landingInfoRow1,
                                invert: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LandingInfoRow, {
                                title: "Support for all the modern frameworks.",
                                desc: "We support all the fancy new frameworks and our platform is powered by open source, scalable technologies.",
                                link: "/docs/general/getting-started/getting-started-overview",
                                linkText: "Read the docs",
                                imgSrc: landingInfoRow2
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_LandingInfoRow, {
                                title: "Integrations with your favorite tools.",
                                desc: "Connect your favorite issue tracker, support tool, or even analytics software and we’ll give you a way to push and pull data in the right places.",
                                link: "/docs/general/integrations/overview",
                                linkText: "Read the docs",
                                imgSrc: landingInfoRow3,
                                invert: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Home_module_default()).infoContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoRow/* default */.Z, {
                            title: "Built with compliance and security.",
                            desc: "Whether its SOC 2, HIPAA, or ISO, highlight.io can work with your stack. Contact us at security@highlight.io for more information.",
                            link: "/docs/general/company/compliance-and-security",
                            imgSrc: landingInfoRowSecurity
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((Home_module_default()).bigHero, (Home_module_default()).hideMobile),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()((Home_module_default()).hero),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                playsInline: true,
                                autoPlay: true,
                                muted: true,
                                loop: true,
                                id: "big-hero-video",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: "/images/big-hero.mp4",
                                    type: "video/mp4"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((Home_module_default()).hero, (Home_module_default()).mobile),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: mobile_insects,
                            alt: "hero"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OSSCallToAction, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompaniesReel/* CompaniesReel */.T, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).anchorFeature,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Home_module_default()).anchorHead,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                                    type: "copy2",
                                    onDark: true,
                                    children: [
                                        "Don't take our word.",
                                        " ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/customers",
                                            children: "Read our customer review section →"
                                        })
                                    ]
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Home_module_default()).slider,
                        ref: reviewsRef,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Home_module_default()).slideTrack,
                            children: [
                                ...Reviews/* REVIEWS */.t,
                                ...Reviews/* REVIEWS */.t
                            ].map((review, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerReview, {
                                    companyLogo: review.companyLogo,
                                    text: review.text,
                                    author: review.author,
                                    scale: review.scale
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 50246:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__2Pzmc","gridSection":"Section_gridSection__vgdkS","noYTopPadding":"Section_noYTopPadding__CWdmK","noYBottomPadding":"Section_noYBottomPadding__efv2e","sectionReverseMobile":"Section_sectionReverseMobile__q0tjM"};

/***/ })

}]);